<div class="SignUp uk-flex-top uk-modal" #modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
		<div class="uk-modal-close-default">
			<span class="IconItem IconItem--close">
				<img src="/assets/img/icon/close.svg" uk-svg>
			</span>
		</div>
        <h2 class="uk-text-center">Регистрация</h2>
		<div class="uk-alert-danger" uk-alert *ngIf='error'><p [innerHtml]="errorMessage"></p></div>
		<div class="uk-alert-success" uk-alert *ngIf='resultMessage && !error'><p [innerHtml]="resultMessage"></p></div>
        <form action="#" method="post" #signupForm="ngForm" (ngSubmit)="submit($event, signupForm)">
            <div class="uk-margin">
				<label class="RadioBtn uk-position-relative uk-flex-inline uk-flex-middle uk-margin-right">
					<input type="radio" name="status" value="privatePerson" (change)="onstatusChange(true)" checked>
					<span class="RadioFlag"></span>
					<span>Физическое лицо</span>
				</label>
                <label class="RadioBtn uk-position-relative uk-flex-inline uk-flex-middle">
					<input type="radio" name="status" value="legalPerson" (change)="onstatusChange(false)">
					<span class="RadioFlag"></span>
					<span>Юридическое лицо</span>
				</label>
            </div>
            <div *ngIf="privateStatus">
                <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="name"
						name="name"
						placeholder="Имя Фамилия"
						required
					>
				</div>
				<!-- <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="login"
						name="login"
						placeholder="Придумайте логин*"
						pattern="^[\w]{5,}$"
						required
					>
				</div> -->
                <div class="uk-margin-small">
					<input class="uk-input"
						type="email"
						[(ngModel)]="email"
						name="email"
						placeholder="Ваш e-mail"
						email
						required
					>
				</div>
                <div class="uk-margin-small">
					<input class="uk-input"
						type="password"
						[(ngModel)]="password"
						name="password"
						placeholder="Придумайте пароль*"
						pattern="^[\S]{6,}$"
						required
					>
				</div>
            </div>
            <div *ngIf="!privateStatus">
                <div class="uk-margin-small"><strong>Контактное лицо</strong></div>
                <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="name"
						name="name"
						placeholder="Имя Фамилия"
						required
					>
				</div>
				<!-- <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="login"
						name="login"
						placeholder="Придумайте логин*"
						pattern="^[\w]{5,}$"
						required
					>
				</div> -->
                <div class="uk-margin-small">
					<input class="uk-input"
						type="email"
						[(ngModel)]="email"
						name="email"
						placeholder="Ваш e-mail"
						email
						required
					>
				</div>
                <div class="uk-margin-small">
					<input class="uk-input"
						type="password"
						[(ngModel)]="password"
						name="password"
						placeholder="Придумайте пароль*"
						pattern="^[\S]{6,}$"
						required
					>
				</div>
                <div class="uk-margin-top"><strong>Компания</strong></div>
                <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="orgName"
						name="orgName"
						placeholder="Название"
						required
					>
				</div>
                <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="legalAddress"
						name="legalAddress"
						placeholder="Юридический адрес"
						required
					>
				</div>
                <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="checkingAccount"
						name="checkingAccount"
						placeholder="Расчетный счет"
						required
					>
				</div>
                <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="inn"
						name="inn"
						placeholder="ИНН"
						required
					>
				</div>
                <div class="uk-margin-small">
					<input class="uk-input"
						type="text"
						[(ngModel)]="kpp"
						name="kpp"
						placeholder="КПП"
						required
					>
				</div>
            </div>
            <div class="uk-margin">
				<button class="uk-button uk-button-primary uk-width-1-1"
					type="submit"
					[disabled]="loadingState || signupForm.form.invalid"
					[ngClass]="loadingState ? 'uk-button-loading' : ''"
				>Завершить регистрацию</button>
			</div>
            <div class="uk-text-muted uk-margin">Нажимая кнопку «Завершить регистрацию»,<br/> Вы автоматически соглашаетесь<br/> с
				<a href="/assets/docs/site-rules.pdf" target="_blank">правилами сайта</a>
			</div>
			<div class="uk-text-muted">* Не менее любых 6 символов, кроме пробела</div>
        </form>
    </div>
</div>
